export default angular
  .module('doxy.common.directives.dNgModelNumber', [])
  .directive('ngModelEmptyAsNull', function () {
    return {
      scope: false,
      require: 'ngModel',
      restrict: 'A',
      link(scope, element, attrs, ngModel) {
        attrs.$observe('ngModel', function (value) {
          scope.$watch(value, function (newValue) {
            if (newValue === '') {
              ngModel.$setViewValue(null);
            }
          });
        });
      },
    };
  }).name;
